<form
    *ngIf="!isLoading"
    [formGroup]="customerFormGroup"
    (ngSubmit)="submit()"
    class="modal-wrapper">
    <div class="modal-header">
        <h2
            *ngIf="!isUpdate"
            class="modal-title"
            id="exampleModalLabel">
            New customer
        </h2>
        <h2
            *ngIf="isUpdate"
            class="modal-title"
            id="exampleModalLabel">
            Edit customer
        </h2>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-6">
                <div class="form-group required m-b-2">
                    <label>Firstname</label>
                    <input
                        type="text"
                        formControlName="firstName"
                        trim="blur"
                        #focussed />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group required m-b-2">
                    <label>Lastname</label>
                    <input
                        type="text"
                        formControlName="lastName"
                        trim="blur" />
                </div>
            </div>
        </div>

        <h3 class="m-t-4 m-b-4">Contact information</h3>

        <div formGroupName="contactInformation">
            <div class="form-group m-b-2 required">
                <label>Phonenumber</label>
                <input
                    type="text"
                    placeholder="Phonenumber"
                    formControlName="phoneNumber"
                    trim="blur" />
            </div>

            <div class="form-group m-b-2 required">
                <label>Emailaddress</label>
                <input
                    type="email"
                    placeholder="Emailaddress"
                    formControlName="email"
                    trim="blur" />
            </div>

            <div class="form-group m-b-2">
                <label>Tags</label>
                <app-global-tags
                    *ngIf="isUpdate"
                    [objectUuid]="customer.uuid"
                    [type]="'customer'"></app-global-tags>
                <app-global-tags
                    *ngIf="!isUpdate"
                    [type]="'customer'"></app-global-tags>
            </div>
        </div>

        <h3 class="m-t-4 m-b-4">Address</h3>

        <div formGroupName="address">
            <div class="m-b-2">
                <div class="row">
                    <div class="col-6">
                        <div class="form-group required">
                            <label>Street</label>
                            <input
                                type="text"
                                placeholder="Street*"
                                formControlName="street"
                                trim="blur" />
                            <span
                                class="form-error"
                                *ngIf="customerFormGroup.get('address.street').errors && customerFormGroup.get('address.street').touched"
                                >Street is required</span
                            >
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="form-group required">
                            <label>Number</label>
                            <input
                                type="number"
                                placeholder="Number*"
                                formControlName="number" />
                            <span
                                class="form-error"
                                *ngIf="customerFormGroup.get('address.number').errors && customerFormGroup.get('address.number').touched"
                                >Number is required</span
                            >
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="form-group">
                            <label>Box</label>
                            <input
                                type="text"
                                placeholder="Box"
                                formControlName="bus"
                                trim="blur" />
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="form-group">
                            <label>Ext</label>
                            <input
                                type="number"
                                placeholder="Ext"
                                formControlName="ext" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="m-b-2">
                <div class="row">
                    <div class="col-3">
                        <div class="form-group required">
                            <label>Zipcode</label>
                            <input
                                type="text"
                                placeholder="Zipcode*"
                                formControlName="postal"
                                trim="blur" />
                            <span
                                class="form-error"
                                *ngIf="customerFormGroup.get('address.postal').errors && customerFormGroup.get('address.postal').touched"
                                >Zipcode is required</span
                            >
                        </div>
                    </div>
                    <div class="col-9">
                        <div class="form-group required">
                            <label>City</label>
                            <input
                                type="text"
                                placeholder="City*"
                                formControlName="city"
                                trim="blur" />
                            <span
                                class="form-error"
                                *ngIf="customerFormGroup.get('address.city').errors && customerFormGroup.get('address.city').touched"
                                >City is required</span
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="form-group m-b-2 required"
                formGroupName="country">
                <label>Country</label>
                <select formControlName="iso2">
                    <option
                        *ngFor="let country of allCountries"
                        [ngValue]="country['alpha-2']">
                        {{ country.name }}
                    </option>
                </select>
                <span
                    class="form-error"
                    *ngIf="customerFormGroup.get('address.country.iso2').errors && customerFormGroup.get('address.country.iso2').touched"
                    >Country is required</span
                >
            </div>
        </div>

        <app-global-autocomplete
            [parentForm]="customerFormGroup"
            [formControlName]="'contact'"
            [data]="contacts$ | async"
            [itemType]="'contact'"
            [label]="'Link a contact'"
            [notFoundMessage]="'Add a contact'"
            [keyword]="'firstName'"
            [placeholder]="'Choose contact'"
            [active]="this.moduleService.checkModuleActive(eModule.CONTACTS)"></app-global-autocomplete>
    </div>

    <div class="modal-footer">
        <button
            type="button"
            class="button button--outline"
            (click)="activeModal.close()">
            Close
        </button>
        <button
            *ngIf="!isUpdate"
            type="submit"
            [ngClass]="{ 'button--loading': loading }"
            class="button button--primary">
            Add customer
        </button>
        <button
            *ngIf="isUpdate"
            type="submit"
            [ngClass]="{ 'button--loading': loading }"
            class="button button--primary">
            Edit customer
        </button>
    </div>
</form>

<div
    *ngIf="isLoading"
    class="modal-wrapper">
    <app-loading-message></app-loading-message>
</div>
